import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiError } from "@/lib/oraya-api";
import { useAuth } from "@/context/AuthContext";
import { OrayaMark } from "@/components/site/primitives";

export default function CommandLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/command", { replace: true });
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  const google = () => {
    const redirectUrl = window.location.origin + "/command";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const input = "w-full bg-transparent border-b border-hairline/20 focus:border-oraya-accent focus:outline-none py-3 text-ink placeholder:text-subtle/50 transition-colors";

  return (
    <div data-theme="light" className="min-h-screen bg-surface flex items-center justify-center px-6">
      <div className="grain" />
      <div className="w-full max-w-md relative z-10">
        <div className="flex flex-col items-center mb-8">
          <OrayaMark size={44} />
          <span className="display text-xl font-medium tracking-[0.24em] text-ink mt-4">ORAYA</span>
          <span className="text-xs uppercase tracking-[0.28em] text-subtle mt-2">Command Center</span>
        </div>
        <div className="glass-heavy rounded-3xl p-8">
          <form onSubmit={submit} className="flex flex-col gap-5" data-testid="command-login-form">
            <input className={input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="command-email" required />
            <input className={input} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="command-password" required />
            <button type="submit" disabled={busy} data-testid="command-login-submit" className="mt-2 rounded-full px-6 py-3 bg-invert text-invert-ink font-medium hover:opacity-90 transition-opacity disabled:opacity-50">
              {busy ? "Signing in…" : "Enter Command Center"}
            </button>
          </form>
          <div className="flex items-center gap-4 my-6"><div className="flex-1 h-px bg-hairline/10" /><span className="text-xs text-subtle">or</span><div className="flex-1 h-px bg-hairline/10" /></div>
          <button onClick={google} data-testid="command-google" className="w-full rounded-full px-6 py-3 glass-medium text-ink font-medium hover:border-hairline/25 transition-colors">Continue with Google</button>
        </div>
      </div>
    </div>
  );
}
